var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.isMobile)?_c('ConfiguratorLevel1Mobile'):_c('ConfiguratorLevel1Desktop')
}
var staticRenderFns = []

export { render, staticRenderFns }